import { render } from "./TableGroups.vue?vue&type=template&id=5a461a56&scoped=true"
import script from "./TableGroups.vue?vue&type=script&lang=js"
export * from "./TableGroups.vue?vue&type=script&lang=js"

import "./TableGroups.vue?vue&type=style&index=0&id=5a461a56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a461a56"]])

export default __exports__